import { render, staticRenderFns } from "./MensagenPronta.vue?vue&type=template&id=6daa4527&scoped=true"
import script from "./MensagenPronta.vue?vue&type=script&lang=js"
export * from "./MensagenPronta.vue?vue&type=script&lang=js"
import style0 from "./MensagenPronta.vue?vue&type=style&index=0&id=6daa4527&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa4527",
  null
  
)

export default component.exports